import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'utils-ui', {
    viewSchema: 'View schema',
    schemaNotRegistered: 'This schema is not in the registry.',
  });
}
